import React, { useRef } from "react";
import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useEffect, useState, useMemo } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useFormik } from "formik";
import * as yup from "yup";
import dayjs from "dayjs";
import { createTheme } from "@mui/material/styles";
import { toast } from "react-toastify";
import axios from "axios";
import { ToastContainer } from "react-toastify/dist";
import Loader from "../../../components/Loader";
import InputLabel from "@mui/material/InputLabel";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";
import { common_axios } from "../../../App";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import moment from "moment/moment";
import Checkbox from "@mui/material/Checkbox";
import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Swal from "sweetalert2";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

export default function HrAddEmployee() {
  const usermodal = JSON.parse(localStorage.getItem("usermodal"));
  // console.log("modal", usermodal.organization);
  const approvvall = useRef(null);
  const markAttendacnerefrr = useRef(null);
  const [Location, setLocation] = React.useState(null);
  const [Designation, setDesignation] = React.useState(null);
  const [Locationarray, setLocationarray] = React.useState(null);
  const [Designationarray, setDesignationarray] = React.useState(null);
  const [Roles, setRoles] = React.useState(null);
  const [Rolesvalue, setRolesvalue] = React.useState(6);
  const [open, setOpen] = useState(false);
  const [state, setstate] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [CSM, setCSM] = useState({});
  const [ADDShow, setADDShow] = useState(true);

  const [joining, setjoining] = React.useState(
    moment(dayjs(new Date())).format("YYYY-MM-DD")
  );

  const handleChangeJoining = (newValue) => {
    // console.log("ddddd", newValue?.$d);
    setjoining(moment(newValue?.$d).format("YYYY-MM-DD"));
  };

  // console.log("kjkjmj", Designation?.designations);

  const [mappedData, setmappedData] = useState({
    desg: "",
    role: "",
    transit: "",
    org: "",
    organisation: "",
  });
  const [dataAutoComplete, setdataAutoComplete] = useState({
    location: null,
    org: null,
  });
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [value, setValue] = React.useState();
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleChangeLocation = (value) => {
    setLocation(value);
  };
  const handleChangeDesignation = (value) => {
    setDesignation(value);
  };
  const [personName, setPersonName] = React.useState([]);
  // console.log("hh", personName);

  const handleChangeMultiLocation = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value?.split(",") : value
    );
  };
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
      },
    },
  });

  // console.log("Rolesvalue", Rolesvalue);

  const fetchRole = async () => {
    try {
      setOpen(true);
      const res = await common_axios(`/employee/v1/roles`);

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
        // console.log("userrrirddd", res.data);
        // setkunuVeer(true);
        await setRoles(res?.data?.roleMaster);

        // x.toLocaleDateString()
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      // await toast.error("Something went wrong", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const fetchLocation = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `/organization/v1/locationByOrganization?organizationName=${usermodal?.organization}&groupId=${Rolesvalue}`
      );
      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        let array = res?.data?.locationMaster;
        for (let i = 0; i < array.length; i++) {
          const ele = array[i];
          ele.id = "";
          // console.log(array);
        }

        await setLocationarray(array);

        // console.log("oorrrgggg", res.data.organizationMaster[0].locationMaster);
      } else {
        setOpen(false);
        await setTimeout(async () => {
          // await toast.error(res.data.statusDescriptions.description, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    } catch (error) {
      setOpen(false);
      console.log(formik.errors);
      console.log(error);
      await setTimeout(async () => {
        // await toast.error("Something went wrong", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 100);
    }
  };

  const fetchDesignation = async () => {
    try {
      setOpen(true);
      const res = await common_axios.get(`/employee/v1/designation`);
      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        await setDesignationarray(res.data.designationEntities);

        // console.log("oorrrgggg111", res.data.designationEntities);
      } else {
        setOpen(false);
        await setTimeout(async () => {
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    } catch (error) {
      setOpen(false);
      console.log(formik.errors);
      console.log(error);
      await setTimeout(async () => {
        // await toast.error("Something went wrong", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 100);
    }
  };

  const fetchCSM = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `/employee/v1/locationCSM?location=${Location?.location}`
      );
      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
        await setCSM({
          firstname: res?.data?.adminUserModels1?.firstName,
          lastname: res?.data?.adminUserModels1?.lastName,
          userid: res?.data?.adminUserModels1?.id,
        });
        setADDShow(false);
        // console.log("oorrrgggg", res.data);
      } else {
        setOpen(false);
        setADDShow(true);
        await setTimeout(async () => {
          // await toast.error(res.data.statusDescriptions.statusDescription, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    } catch (error) {
      setOpen(false);
      setADDShow(true);
      // console.log(formik.errors);
      console.log(error);
      await setTimeout(async () => {
        // await toast.error("Something went wrong", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 100);
    }
  };

  useEffect(async () => {
    fetchRole();
    fetchLocation();
    fetchDesignation();
  }, [Rolesvalue]);
  useEffect(async () => {
    if (Location != null) {
      fetchCSM();
      setADDShow(false);
    } else {
      setADDShow(true);
    }
  }, [Location]);
  useEffect(async () => {
    if (personName.length != 0) {
      setADDShow(false);
    } else {
      setADDShow(true);
    }
  }, [personName]);

  // console.log("dnhio", Rolesvalue);

  useEffect(() => {
    setLocation(null);
    setDesignationarray([]);
    setPersonName([]);
  }, [Rolesvalue]);

  const resetValues = useRef(null);

  const resetter = () => {
    resetValues.current.click();
  };

  const validationSchema = yup.object({
    payrollid: yup
      .number("Enter your Payroll-Id")
      .min(10, "Payroll-Id should be of minimum 2 characters length")
      .max(1000000, "Payroll-Id should be of maximum 7 characters length")
      .required("Payroll-Id is required"),
    unanumbar: yup.number("Enter your UAN-numbar"),
    // .min(10, "UAN-numbar should be of minimum 2 characters length")
    // .max(100000000000, "UAN-numbar should be of maximum 12 characters length")
    // .required("Payroll-Id is required"),
    branch: yup.string("Enter your Branch"),
    // .min(10, "UAN-numbar should be of minimum 2 characters length")
    // .max(100000000000, "UAN-numbar should be of maximum 12 characters length")
    // .required("Payroll-Id is required"),
    ifscCode: yup.string("Enter your IFSC-Code"),
    // .min(10, "UAN-numbar should be of minimum 2 characters length")
    // .max(100000000000, "UAN-numbar should be of maximum 12 characters length")
    // .required("Payroll-Id is required"),
    bank: yup.string("Enter your Bank"),
    // .min(10, "UAN-numbar should be of minimum 2 characters length")
    // .max(100000000000, "UAN-numbar should be of maximum 12 characters length")
    // .required("Payroll-Id is required"),
    accountNumber: yup.number("Enter your Account Number"),
    // .min(10, "UAN-numbar should be of minimum 2 characters length")
    // .max(100000000000, "UAN-numbar should be of maximum 12 characters length")
    // .required("Payroll-Id is required"),
    lastname: yup
      .string("Enter Your Last Name")
      .min(2, "Last Name should be of minimum 2 characters length")
      // .matches(
      //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
      //   "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      // )
      .required("Last Name required"),
    firstname: yup
      .string("Enter your First Name ")
      .min(2, "First Name should be of minimum 2 characters length")
      .required("First Name is required"),
    // designation: yup
    //   .string("Enter your Designation ")
    //   .min(2, "Designation should be of minimum 2 characters length")
    //   .required("Designation is required"),
    username: yup
      .string("Enter Your Username")
      .min(3, "Username should be at least 3 characters long")
      .required("*Username is required")
      .matches(/^(\S+$)/g, "* This field cannot contain  blankspaces"),
    emailaddress: yup.string().email("E-Mail must be valid").max(255),
    contact: yup
      .number("Enter your PhoneNumber")
      .min(1000000000, "PhoneNumber should be of minimum 10 characters length")
      .max(
        100000000000,
        "PhoneNumber should be of maximum 11 characters length"
      ),
    // .required("PhoneNumber is required"),
    adhaar: yup
      .string("Enter Your Aadhaar Number")
      // .required("Aadhaar Number Is Required")
      .matches(/^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/, {
        message: "Invalid Aadhaar Number Valid Example Like: 78XX 45XX 97XX",
      }),
    pan: yup
      .string("Enter Your PAN Number")
      .matches(/(([A-Z]){5}([0-9]){4}([A-Z]){1}$)/, {
        message: "Invalid PAN Number Valid Example Like: ALWPG5809L",
        // excludeEmptyString: true,
      }),
    address: yup
      .string("Enter Your Address")
      // .min(2, "Employee Name should be of minimum 2 characters length")
      .required("Enter Your Address"),
    // .matches(/(([A-Z]){5}([0-9]){4}([A-Z]){1}$)/, {
    //   message: "Invalid PAN Number Valid Example Like: ALWPG5809L",
    //   // excludeEmptyString: true,
    // }),
  });

  const formik = useFormik({
    initialValues: {
      city: "",
      contact: "",
      lastname: "",
      firstname: "",
      // designation: "",
      username: "",
      emailaddress: "",
      state: "",
      payrollid: "",
      unanumbar: "",
      name: "",
      hrcCsm: "",
      csmManager: "",
      locationClass: "",
      status: "",
      adhaar: "",
      pan: "",
      address: "",
      branch: "",
      ifscCode: "",
      bank: "",
      accountNumber: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,

    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await common_axios.post(`/api/auth/v1/createPassword`, {
          email: values.email,
          enabled: true,
          firstName: values.firstname,
          lastName: values.lastname,
          mobileNo: values.contact,
          organization: usermodal?.organization,
          location: Location?.location,
          aadharCard: values.adhaar.replace(/\s/g, ""),
          payrollId: values.payrollid,
          password: "Abuzz@1234",
          userGroups: Rolesvalue,
          username: values.username,
          associateId: CSM?.userid,
          uanNumber: values.unanumbar,
          address: values.address,
          csmLocationId: Location?.id,
          designation: Designation?.designations,
          dateOfJoining: joining,
          firstTimeLogIn: "0",
          requests:
            Rolesvalue === 7
              ? personName
              : [
                  {
                    location: "",
                    city: "",
                    state: "",
                    organisationId: "",
                  },
                ],
          // [
          //   {
          //     location: "Navi mumbai-1",
          //     city: "Navi mumbai",
          //     state: "Maharashtra",
          //     organisationId: "",
          //   },
          //   {
          //     location: "Navi mumbai-2",
          //     city: "Navi mumbai",
          //     state: "Maharashtra",
          //     organisationId: "",
          //   },
          // ],
          bankDetail: [
            {
              accountNumber: values.accountNumber,
              bank: values.bank,
              ifscCode: values.ifscCode,
              branch: values.branch,
              panNumber: values.pan,
            },
          ],
          //   bankDetail: [
          //     {
          //         accountNumber: "416541651",
          //         bank: "sbi",
          //         ifscCode: "vbhj456",
          //         branch: "ynr",
          //         panNumber: "vjsfdh545"
          //     }
          // ]
        });
        if (res.data.statusDescriptions.statusCode == 200) {
          if (Rolesvalue === 6) {
            await setTimeout(async () => {
              // await toast.success("Emoloyee Created SuccessFully", {
              //   theme: "colored",
              // });
              Swal.fire({
                icon: "success",
                // title: "Oops...",
                text: "Emoloyee Created SuccessFully",
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }, 100);
          } else if (Rolesvalue === 7) {
            await setTimeout(async () => {
              // await toast.success("Csm Created SuccessFully", {
              //   theme: "colored",
              // });
              Swal.fire({
                icon: "success",
                // title: "Oops...",
                text: "Csm Created SuccessFully",
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }, 100);
          }

          setOpen(false);
          markAttendacnerefrr.current.click();
          resetValues.current.click();
          await formik.handleReset();
          setLocation(null);
          setPersonName([]);
          setRolesvalue(6);
          await resetter();
        } else {
          setOpen(false);
          // markAttendacnerefrr.current.click();
          // setLocation(null);
          // setPersonName([]);
          // setRolesvalue(6);
          // resetValues.current.click();
          await setTimeout(async () => {
            // await toast.error(res.data.statusDescriptions.statusDescription, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: res.data.statusDescriptions.statusDescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        }
      } catch (error) {
        setOpen(false);
        // markAttendacnerefrr.current.click();
        // setLocation(null);
        // setPersonName([]);
        // setRolesvalue(6);
        // resetValues.current.click();
        // console.log(formik.errors);
        console.log({ error });
        await setTimeout(async () => {
          // await toast.error("Something went wrong", {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    },
  });

  useEffect(() => {
    //for addhar number----------------------

    document.getElementById("adh").addEventListener("input", function (e) {
      var target = e.target,
        position = target.selectionEnd,
        length = target.value.length;
      let addharVal = target.value.replace(/\s/g, "");
      if (addharVal.length > 12) {
        target.value = addharVal.slice(0, 12);
      }
      target.value = target.value
        .replace(/[^\dA-Z]/g, "")
        .replace(/(.{4})/g, "$1 ")
        .trim();
      target.selectionEnd = position +=
        target.value.charAt(position - 1) === " " &&
        target.value.charAt(length - 1) === " " &&
        length !== target.value.length
          ? 1
          : 0;
      // console.log("target", target.value.replace(/\s/g, ""));
      formik.setFieldValue("adhaar", target.value, false);
    });
    //addhar number end --------------------
    // pan number-----------------------------
    document.getElementById("pn").addEventListener("input", function (e) {
      var target = e.target,
        position = target.selectionEnd,
        length = target.value.length;
      let addharVal = target.value.replace(/\s/g, "");
      if (addharVal.length > 10) {
        target.value = addharVal.slice(0, 10);
      }
      target.value = target.value.toUpperCase();
      // console.log("pn", target.value);
      formik.setFieldValue("pan", target.value, false);
    });
    //pan number end ------------------------------

    document.getElementById("gml").addEventListener("input", function (e) {
      var target = e.target,
        position = target.selectionEnd,
        length = target.value.length;
      let addharVal = target.value.replace(/\s/g, "");
      if (addharVal.length > 50) {
        target.value = addharVal.slice(0, 50);
      }
      // target.value = target.value.match(/^[A-Za-z]+$/);
      // console.log("gml", target.value);
      formik.setFieldValue("emailaddress", target.value, false);
    });
  }, []);

  return (
    <>
      {" "}
      <section class="form_card mt-5">
        <ToastContainer autoClose={5000} />

        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
        {/* -------------------------- modal --------------------------*/}

        <button
          id="Change"
          ref={approvvall}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop98"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal mark fade"
          id="staticBackdrop98"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" style={{ width: "80%" }}>
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-content">
                <div className="modal-header">
                  {Rolesvalue === 7 ? (
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Add CSM
                    </h5>
                  ) : Rolesvalue === 6 ? (
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Add Employee
                    </h5>
                  ) : (
                    <></>
                  )}

                  <button
                    ref={markAttendacnerefrr}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      // markAttendacnerefrr.current.click();
                      resetValues.current.click();
                    }}
                  ></button>
                </div>
                <div className="modal-body">
                  <ThemeProvider theme={theme}>
                    {/* <form onSubmit={formik.handleSubmit} class="m-0"> */}
                    <div class="row mt-3" id="add_emp">
                      <div className="col-md-3">
                        <TextField
                          required
                          className="w-100"
                          label="First Name"
                          name="firstname"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={formik.values.firstname}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.firstname &&
                            Boolean(formik.errors.firstname)
                          }
                          helperText={
                            formik.touched.firstname && formik.errors.firstname
                          }
                        />
                      </div>
                      <div className="col-md-3 my_3">
                        <TextField
                          required
                          className="w-100"
                          label="Last name"
                          name="lastname"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={formik.values.lastname}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.lastname &&
                            Boolean(formik.errors.lastname)
                          }
                          helperText={
                            formik.touched.lastname && formik.errors.lastname
                          }
                        />
                      </div>
                      <div className="col-md-3">
                        <TextField
                          required
                          className="w-100"
                          label="Username"
                          name="username"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={formik.values.username}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.username &&
                            Boolean(formik.errors.username)
                          }
                          helperText={
                            formik.touched.username && formik.errors.username
                          }
                        />
                      </div>

                      <div className="col-md-3 mt_3">
                        <TextField
                          required
                          className="w-100"
                          label="Payroll-Id"
                          name="payrollid"
                          variant="outlined"
                          size="small"
                          type="number"
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 6);
                          }}
                          value={formik.values.payrollid}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.payrollid &&
                            Boolean(formik.errors.payrollid)
                          }
                          helperText={
                            formik.touched.payrollid && formik.errors.payrollid
                          }
                        />
                      </div>
                    </div>
                    <div class="row mt-4" id="add_emp">
                      <div className="col-md-3">
                        <TextField
                          // required
                          className="w-100"
                          label="Contact No."
                          name="contact"
                          variant="outlined"
                          size="small"
                          type="number"
                          value={formik.values.contact}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.contact &&
                            Boolean(formik.errors.contact)
                          }
                          helperText={
                            formik.touched.contact && formik.errors.contact
                          }
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 10);
                          }}
                        />
                      </div>

                      <div className="col-md-3 mt_3">
                        <TextField
                          // required
                          id="gml"
                          className="w-100"
                          label="E-Mail"
                          name="email"
                          variant="outlined"
                          size="small"
                          type="emailaddress"
                          value={formik.values.emailaddress}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.emailaddress &&
                            Boolean(formik.errors.emailaddress)
                          }
                          helperText={
                            formik.touched.emailaddress &&
                            formik.errors.emailaddress
                          }
                        />
                      </div>

                      {/* <div className="col-md-3 my_3">
                        <TextField
                          // required
                          className="w-100"
                          label="Designation"
                          name="designation"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={formik.values.designation}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.designation &&
                            Boolean(formik.errors.designation)
                          }
                          helperText={
                            formik.touched.designation &&
                            formik.errors.designation
                          }
                        />
                      </div> */}
                      {Rolesvalue === 6 ? (
                        <>
                          <div className="col-md-3">
                            <Autocomplete
                              disablePortal
                              value={Designation}
                              aria-required
                              clearOnBlur={true}
                              className="w-100"
                              id="combo-box-demo"
                              size="small"
                              // options={top100Films}
                              options={Designationarray}
                              getOptionLabel={(option) =>
                                option?.designations || ""
                              }
                              onChange={(e, value) =>
                                handleChangeDesignation(value)
                              }
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField
                                  required
                                  {...params}
                                  label="Designation"
                                />
                              )}
                            />
                          </div>
                        </>
                      ) : (
                        <></>
                      )}

                      {/* <div className="col-md-3">
                          <FormControl required fullWidth>
                            <InputLabel
                              size="small"
                              id="demo-simple-select-label"
                            >
                              Cost Bucket
                            </InputLabel>
                            <Select
                              size="small"
                              required
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={location.csmManager}
                              label="Cost Bucket"
                              onChange={(e) => {
                                setLocation({
                                  ...location,
                                  csmManager: e.target.value,
                                });
                              }}
                            >
                              {mappedData.desg &&
                                mappedData?.desg?.map((map) => {
                                  return (
                                    <MenuItem value={map.designationid}>
                                      {map.designation}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </div> */}
                    </div>

                    <div class="row mt-4" id="add_emp">
                      <div className="col-md-3">
                        <TextField
                          // disabled
                          InputProps={{
                            readOnly: true,
                          }}
                          className="w-100"
                          label="Organisation"
                          name="Organisation"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={usermodal?.organization}
                        />
                      </div>

                      <div className="col-md-3 my_3 forcss locationsign">
                        {Rolesvalue === 6 ? (
                          <>
                            <TextField
                              // disabled
                              InputProps={{
                                readOnly: true,
                              }}
                              className="w-100"
                              label="Location"
                              name="Location"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={Location?.location}
                            />
                          </>
                        ) : Rolesvalue === 7 ? (
                          <>
                            <FormControl className="w-100">
                              <InputLabel id="demo-multiple-checkbox-label">
                                Location
                              </InputLabel>
                              <Select
                                readOnly={true}
                                fullWidth
                                // className="w-100"
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                required
                                size="small"
                                value={personName}
                                onChange={handleChangeMultiLocation}
                                input={<OutlinedInput label="Location" />}
                                renderValue={(selected) =>
                                  selected.map((x) => x?.location).join(", ")
                                }
                                MenuProps={MenuProps}
                              >
                                {Locationarray?.map((val) => (
                                  <MenuItem key={val?.id} value={val}>
                                    <Checkbox
                                      checked={personName?.indexOf(val) > -1}
                                    />
                                    <ListItemText primary={val?.location} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div class="col-md-3 width_3">
                        <div class="input-group input-group-outline mrgin_">
                          <TextField
                            required
                            className="w-100"
                            label="Address"
                            name="address"
                            variant="outlined"
                            size="small"
                            // type="email"
                            value={formik.values.address}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.address &&
                              Boolean(formik.errors.address)
                            }
                            helperText={
                              formik.touched.address && formik.errors.address
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mt_3">
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          style={{ zIndex: "10px" }}
                          fullWidth
                        >
                          <DesktopDatePicker
                            minDate={dayjs(new Date())}
                            style={{ zIndex: "10px" }}
                            label="Joining Date"
                            inputFormat="MM/DD/YYYY"
                            value={joining}
                            helperText={"(Format - mm/dd/yyyy hh:mm (A/P)m)"}
                            onChange={handleChangeJoining}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                style={{ zIndex: "10px" }}
                                required
                                fullWidth
                                className="w-100"
                                {...params}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="row mt-3" id="add_emp">
                      <div class="col-md-3 width_3">
                        <div class="input-group input-group-outline mrgin_">
                          <TextField
                            // required
                            id="adh"
                            className="w-100"
                            label="Aadhaar Card Number"
                            size="small"
                            placeholder="78XX 45XX 97XX"
                            type="text"
                            name="adhaar"
                            value={formik.values.adhaar}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.adhaar &&
                              Boolean(formik.errors.adhaar)
                            }
                            helperText={
                              formik.touched.adhaar && formik.errors.adhaar
                            }
                          />
                        </div>
                      </div>
                      {/* <div class="col-md-3 width_3 my_3">
                        <div class="input-group input-group-outline mrgin_">
                          <TextField
                            // required
                            id="pn"
                            className="w-100"
                            label="PAN Card Number"
                            size="small"
                            placeholder="ALWPG5809L"
                            //   defaultValue="Small"
                            type="text"
                            name="pan"
                            value={formik.values.pan}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.pan && Boolean(formik.errors.pan)
                            }
                            helperText={formik.touched.pan && formik.errors.pan}
                          />
                        </div>
                      </div> */}
                      <div className="col-md-3">
                        <TextField
                          // required
                          className="w-100"
                          label="UAN-number"
                          name="unanumbar"
                          variant="outlined"
                          size="small"
                          type="number"
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 12);
                          }}
                          value={formik.values.unanumbar}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.unanumbar &&
                            Boolean(formik.errors.unanumbar)
                          }
                          helperText={
                            formik.touched.unanumbar && formik.errors.unanumbar
                          }
                        />
                      </div>
                    </div>
                    <Divider className="mt-3" textAlign="center">
                      <b> Bank Details</b>
                    </Divider>
                    <div className="row mt-3">
                      <div className="col-md-3">
                        <TextField
                          // required
                          className="w-100"
                          label="Account Number"
                          name="accountNumber"
                          variant="outlined"
                          size="small"
                          type="number"
                          // onInput={(e) => {
                          //   e.target.value = Math.max(
                          //     0,
                          //     parseInt(e.target.value)
                          //   )
                          //     .toString()
                          //     .slice(0, 12);
                          // }}
                          value={formik.values.accountNumber}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.accountNumber &&
                            Boolean(formik.errors.accountNumber)
                          }
                          helperText={
                            formik.touched.accountNumber &&
                            formik.errors.accountNumber
                          }
                        />
                      </div>
                      <div className="col-md-3">
                        <TextField
                          // required
                          className="w-100"
                          label="Bank Name"
                          name="bank"
                          variant="outlined"
                          size="small"
                          type="text"
                          // onInput={(e) => {
                          //   e.target.value = Math.max(
                          //     0,
                          //     parseInt(e.target.value)
                          //   )
                          //     .toString()
                          //     .slice(0, 12);
                          // }}
                          value={formik.values.bank}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.bank && Boolean(formik.errors.bank)
                          }
                          helperText={formik.touched.bank && formik.errors.bank}
                        />
                      </div>
                      <div className="col-md-3">
                        <TextField
                          // required
                          className="w-100"
                          label="IFSC Code"
                          name="ifscCode"
                          variant="outlined"
                          size="small"
                          type="text"
                          // onInput={(e) => {
                          //   e.target.value = Math.max(
                          //     0,
                          //     parseInt(e.target.value)
                          //   )
                          //     .toString()
                          //     .slice(0, 12);
                          // }}
                          value={formik.values.ifscCode}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.ifscCode &&
                            Boolean(formik.errors.ifscCode)
                          }
                          helperText={
                            formik.touched.ifscCode && formik.errors.ifscCode
                          }
                        />
                      </div>
                      <div className="col-md-3">
                        <TextField
                          // required
                          className="w-100"
                          label="Branch"
                          name="branch"
                          variant="outlined"
                          size="small"
                          type="text"
                          // onInput={(e) => {
                          //   e.target.value = Math.max(
                          //     0,
                          //     parseInt(e.target.value)
                          //   )
                          //     .toString()
                          //     .slice(0, 12);
                          // }}
                          value={formik.values.branch}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.branch &&
                            Boolean(formik.errors.branch)
                          }
                          helperText={
                            formik.touched.branch && formik.errors.branch
                          }
                        />
                      </div>
                      <div class="col-md-3 width_3 mt-3">
                        <div class="input-group input-group-outline mrgin_">
                          <TextField
                            // required
                            id="pn"
                            className="w-100"
                            label="PAN Card Number"
                            size="small"
                            placeholder="ALWPG5809L"
                            //   defaultValue="Small"
                            type="text"
                            name="pan"
                            value={formik.values.pan}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.pan && Boolean(formik.errors.pan)
                            }
                            helperText={formik.touched.pan && formik.errors.pan}
                          />
                        </div>
                      </div>
                    </div>
                    {/* </form> */}
                  </ThemeProvider>
                </div>

                <div className="modal-footer justify-content-between">
                  {/* <Button
                    data-bs-dismiss="modal"
                    sx={{ marginLeft: "10px", background: "#4C4234" }}
                    variant="contained"
                    // endIcon={<CancelIcon />}
                    type="button"
                    className="m-0"
                    onClick={() => {
                      markAttendacnerefrr.current.click();
                      resetValues.current.click();
                    }}
                  >
                    Close
                  </Button> */}
                  {/* <div class="text-end my-4"> */}

                  <Button
                    ref={resetValues}
                    onClick={() => {
                      formik.handleReset();
                      // setLocation({
                      //   hrcCsm: "",
                      //   csmManager: "",
                      //   locationClass: "",
                      //   status: "",
                      // });
                      setstate("");
                      setValue(null);
                      setdataAutoComplete({
                        location: null,
                        org: null,
                      });
                    }}
                    sx={{ marginLeft: "10px", background: "#4C4234" }}
                    type="reset"
                    variant="contained"
                    endIcon={<RestartAltIcon />}
                  >
                    Reset
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={buttonDisable}
                    sx={{ background: "#F67503" }}
                    endIcon={<SendIcon />}
                  >
                    Submit
                  </Button>
                </div>
                {/* <Button
                    sx={{ marginLeft: "10px", background: "#F96902" }}
                    variant="contained"
                    // endIcon={<CheckCircleIcon />}
                    type="submit"
                  >
                    Confirm
                  </Button> */}
                {/* </div> */}
              </div>
            </form>
          </div>
        </div>

        {/* -------------------------- end --------------------------- */}
        <div class="container-fluid">
          <div class="card d-block" id="new_store_entry">
            <div class="card-header p-3 position-relative border-0 bg-white">
              <div class="ttl_bx position-absolute d-flex mt_n4">
                <i class="fas fa-user d-block m-auto"></i>
              </div>
              <div class="d-flex justify-content-between title_8 ms_5">
                <p>Add Employee</p>
                <p class="text-sm mb-0 text-capitalize fw-bold">
                  Fields mark with!!
                  <span class="text-danger fw-bold">*</span> are mandatory.
                </p>
              </div>
            </div>
            <div class="card-body p-4 mt-5">
              <div class="card card_8 d-block">
                <div class="d-flex align-items-center w_30 mt_n3 ms-5 me-auto">
                  <i class="fas fa-envelope d-block" aria-hidden="true"></i>
                  <span class="d-block w-100 text-uppercase ms-2">
                    Add Employee Form
                  </span>
                </div>
                <div class="card-body">
                  <ThemeProvider theme={theme}>
                    {/* </div> */}
                    <div className="row" id="add_emp">
                      <div className="col-md-3">
                        <FormControl required fullWidth>
                          <InputLabel
                            size="small"
                            id="demo-simple-select-label"
                          >
                            Role
                          </InputLabel>
                          <Select
                            size="small"
                            required
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={Rolesvalue}
                            label="Role"
                            onChange={(e) => {
                              setRolesvalue(e.target.value);
                            }}
                          >
                            {Roles &&
                              Roles?.map((map) => {
                                return (
                                  <MenuItem value={map.id}>{map.name}</MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-3 my_3">
                        {/* <Autocomplete
                          disablePortal
                          value={Organisation}
                          aria-required
                          clearOnBlur={true}
                          className="w-100"
                          id="combo-box-demo"
                          size="small"
                          // options={top100Films}
                          options={[]}
                          getOptionLabel={(option) => option.stateName || ""}
                          onChange={(e, value) =>
                            handleChangeOrganisation(value)
                          }
                          sx={{ width: 300 }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Organisation"
                            />
                          )}
                        /> */}
                        <TextField
                          // disabled
                          InputProps={{
                            readOnly: true,
                          }}
                          className="w-100"
                          label="Organisation"
                          name="Organisation"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={usermodal?.organization}
                          // onChange={formik.handleChange}
                          // error={
                          //   formik.touched.username &&
                          //   Boolean(formik.errors.username)
                          // }
                          // helperText={
                          //   formik.touched.username && formik.errors.username
                          // }
                        />
                      </div>
                      {Rolesvalue === 6 ? (
                        <>
                          {" "}
                          <div className="col-md-3">
                            <Autocomplete
                              disablePortal
                              value={Location}
                              aria-required
                              clearOnBlur={true}
                              className="w-100"
                              id="combo-box-demo"
                              size="small"
                              // options={top100Films}
                              options={Locationarray ? Locationarray : []}
                              getOptionLabel={(option) =>
                                option?.location || ""
                              }
                              onChange={(e, value) =>
                                handleChangeLocation(value)
                              }
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField
                                  required
                                  {...params}
                                  label="Location"
                                />
                              )}
                            />
                          </div>
                        </>
                      ) : Rolesvalue === 7 ? (
                        <>
                          {" "}
                          <div className="col-md-3">
                            <FormControl className="w-100">
                              <InputLabel id="demo-multiple-checkbox-label">
                                Location
                              </InputLabel>
                              <Select
                                fullWidth
                                className="w-100"
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                required
                                size="small"
                                value={personName}
                                onChange={handleChangeMultiLocation}
                                input={<OutlinedInput label="Location" />}
                                renderValue={(selected) =>
                                  selected?.map((x) => x?.location)?.join(", ")
                                }
                                MenuProps={MenuProps}
                              >
                                {Locationarray?.map((val) => (
                                  <MenuItem key={val?.id} value={val}>
                                    <Checkbox
                                      checked={personName?.indexOf(val) > -1}
                                    />
                                    <ListItemText primary={val?.location} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}

                      {Rolesvalue === 6 && (
                        <div className="col-md-3 mt_3">
                          {Location == null || ADDShow == true ? (
                            <TextField
                              // disabled
                              InputProps={{
                                readOnly: true,
                              }}
                              className="w-100"
                              label="CSM"
                              name="csm"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={""}
                            />
                          ) : (
                            <TextField
                              // disabled
                              InputProps={{
                                readOnly: true,
                              }}
                              className="w-100"
                              label="CSM"
                              name="csm"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={
                                CSM && CSM?.firstname + "." + CSM?.lastname
                              }
                            />
                          )}
                        </div>
                      )}
                    </div>
                    {/* <div class="text-end my-4"> */}
                    <div className="row mt-3">
                      <div className="col-md-3">
                        <Button
                          disabled={ADDShow}
                          type="button"
                          variant="contained"
                          // disabled={buttonDisable}
                          sx={{ background: "#F67503" }}
                          // endIcon={<SendIcon />}
                          onClick={() => {
                            approvvall.current.click();
                          }}
                        >
                          ADD
                        </Button>
                      </div>
                    </div>
                  </ThemeProvider>

                  {/* <div className="text-end">
                    <p> List of Employees </p>
                    <Link className="primary" to="/dashboard/ViewEmployees">
                      <p style={{ color: "#F47C03" }}>Click here !!</p>
                    </Link>
                  </div> */}

                  {/* <div class="d-flex w-25 mx-auto mt-4"> */}
                  {/* <div class="text-end my-4">
                        <Button
                          type="submit"
                          variant="contained"
                          endIcon={<SendIcon />}
                        >
                          Submit
                        </Button>
                        <Button
                          onClick={() => {
                            formik.handleReset();
                          }}
                          sx={{ marginLeft: "10px" }}
                          type="reset"
                          variant="contained"
                          endIcon={<RestartAltIcon />}
                        >
                          Reset
                        </Button>
                      </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
